import { render, staticRenderFns } from "./PaywallOverlay.vue?vue&type=template&id=48d1febc&"
import script from "./PaywallOverlay.vue?vue&type=script&lang=js&"
export * from "./PaywallOverlay.vue?vue&type=script&lang=js&"
import style0 from "./PaywallOverlay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports